import { api } from './api';

/** Intervalo de cobro (1a): mensual o anual (anual = mensual × 11, un mes gratis). */
export type BillingInterval = 'monthly' | 'yearly';

export interface PricingInterval {
  baseAmount: number;          // centavos MXN
  branchUnitAmount: number;    // centavos MXN por sucursal adicional (+30%)
  subtotal: number;            // base + sucursales extra, pre-descuento
  discountPercent: number;     // 0 | 10 | 30
  discountedSubtotal: number;
  iva: number;                 // 16% del subtotal ya descontado
  total: number;
  couponDurationLabel: string | null; // "primer mes" / "primeros 6 meses" / ...
}

export interface BillingPricing {
  plan: string;
  /** false para Flow (crm): sin sucursales ni cargo por sucursal (ajuste 1a). */
  branchesApply: boolean;
  activeBranches: number;
  extraBranches: number;
  discount: string | null; // 'fundador' | 'adopcion' | 'referido' | null
  /** ¿El descuento vence? (lo decide el backend por la vigencia, no el nombre del tipo). */
  discountExpires: boolean;
  intervals: Record<BillingInterval, PricingInterval>;
}

/** Preview de precios server-side (base + sucursales + cupón + IVA) para el selector. */
export function getBillingPricing(): Promise<BillingPricing> {
  return api<BillingPricing>('/billing/pricing');
}

/**
 * §17.6 — dispara el Checkout de Stripe: pide una Checkout Session FRESCA al backend
 * (price/cupón/quantity de sucursales se resuelven server-side; el cliente solo
 * elige el intervalo) y redirige a la URL hospedada de Stripe. Al volver
 * (success_url), el webhook ya flipó subscription_active.
 *
 * Siempre se genera in-app (las Checkout Sessions caducan → nunca se mete una URL de
 * Stripe en correos/banners; esos llevan a la app y aquí se crea fresca).
 */
export async function startCheckout(interval: BillingInterval = 'monthly'): Promise<void> {
  const res = await api<{ url: string }>('/billing/checkout-session', {
    method: 'POST',
    body: { interval },
  });
  if (res?.url) window.location.href = res.url;
  else throw new Error('No se recibió URL de Checkout.');
}
